import { render, staticRenderFns } from "./Mailing.vue?vue&type=template&id=5f0beec6&scoped=true&"
import script from "./Mailing.vue?vue&type=script&lang=js&"
export * from "./Mailing.vue?vue&type=script&lang=js&"
import style0 from "./Mailing.vue?vue&type=style&index=0&id=5f0beec6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0beec6",
  null
  
)

export default component.exports